const API_URL = process.env.REACT_APP_SERVER_URL;

/**
 * @param {Object} [options]
 * @param {boolean} [options.all] - If true, returns all active pass types (including showOnSchedule: false). Use for admin/add-pass.
 */
export const getPassTypes = async (options = {}) => {
  try {
    const url = options.all ? `${API_URL}/passes/types?all=true` : `${API_URL}/passes/types`;
    const res = await fetch(url);
    if (!res.ok) throw new Error("Failed to fetch pass types");
    return await res.json();
  } catch (error) {
    console.error("Error fetching pass types:", error);
    return [];
  }
};

export const purchasePass = async (passTypeId, token, isSubscription = false, classId = null) => {
  try {
    const res = await fetch(`${API_URL}/passes/purchase`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ 
        passTypeId, 
        isSubscription,
        classId
      }),
    });
    if (!res.ok) throw new Error("Failed to purchase pass");
    return await res.json();
  } catch (error) {
    console.error("Error purchasing pass:", error);
    throw error;
  }
};

export const cancelSubscription = async (passId, token) => {
  try {
    const res = await fetch(`${API_URL}/passes/cancel-subscription`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ passId }),
    });
    if (!res.ok) throw new Error("Failed to cancel subscription");
    return await res.json();
  } catch (error) {
    console.error("Error cancelling subscription:", error);
    throw error;
  }
};

export const giftPurchase = async (passTypeId, recipientEmail, options = {}) => {
  try {
    const body = { passTypeId, recipientEmail };
    if (options.backUrl)          body.backUrl          = options.backUrl;
    if (options.successFrom)      body.successFrom      = options.successFrom;
    if (options.context)          body.context          = options.context;
    if (options.registrantName)   body.registrantName   = options.registrantName;
    if (options.registrantPhone)  body.registrantPhone  = options.registrantPhone;
    const res = await fetch(`${API_URL}/passes/gift-purchase`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || "Failed to create gift payment");
    return data;
  } catch (error) {
    console.error("Error creating gift payment:", error);
    throw error;
  }
};

export const claimGift = async (claimCode, token) => {
  try {
    const res = await fetch(`${API_URL}/passes/claim-gift`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ claimCode }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || "Failed to claim gift");
    return data;
  } catch (error) {
    console.error("Error claiming gift:", error);
    throw error;
  }
};

export const payUnpaidPass = async (passId, token) => {
  try {
    const res = await fetch(`${API_URL}/passes/pay-unpaid/${passId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      const errData = await res.json().catch(() => ({}));
      throw new Error(errData.error || "Failed to create payment");
    }
    return await res.json();
  } catch (error) {
    console.error("Error paying for unpaid pass:", error);
    throw error;
  }
};